<div
  class="c05-compare-modal"
  #compareModal
  role="dialog"
  aria-modal="true"
  [attr.aria-label]="ariaLabelCopy[jsonKey.COMPARE_MODAL_ARIA_LABEL]"
  [cdkTrapFocus]="activateFocusTrap"
>
  <header class="chromecast-container" data-animation="c05-compare-modal-content">
    <div class="img-container">
      <picture>
        <source
          srcset="{{'/assets/images/compare/chromecast-compare.webp' | assetpipe }}"
          type="image/webp"
        />
        <source
          srcset="{{ '/assets/images/compare/chromecast-compare.jpg' | assetpipe }}"
          type="image/jpeg"
        />
        <img
          width="93"
          height="195"
          alt=""
          class="remote-img"
          src="{{ '/assets/images/compare/chromecast-compare.jpg' | assetpipe }}"
        />
      </picture>
      <picture>
        <source
          srcset="{{ '/assets/images/compare/chromecast-compare.webp' | assetpipe }}"
          type="image/webp"
        />
        <source
          srcset="{{ '/assets/images/compare/chromecast-compare.jpg' | assetpipe }}"
          type="image/jpeg"
        />
        <img
          width="93"
          height="195"
          alt=""
          class="remote-img"
          src="{{ '/assets/images/compare/chromecast-compare.jpg' | assetpipe }}"
        />
      </picture>
    </div>
    <button
      class="close-modal-toggle"
      #closeButtonRef
      (click)="onCloseButtonClick()"
      data-animation="c05-compare-modal-content"
      [attr.aria-label]="ariaLabelCopy[jsonKey.CLOSE_BUTTON_ARIA_LABEL]"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15" fill="currentColor">
        <path d="M15 1.5 13.5 0l-6 6-6-6L0 1.5l6 6-6 6L1.5 15l6-6 6 6 1.5-1.5-6-6 6-6z" />
      </svg>
    </button>
  </header>
  <div class="compare-main-content" #scrollContent (scroll)="handleScroll($event)">
    <table class="content-scroll" data-animation="c05-compare-modal-content">
      <tr class="compare-titles">
        <th class="chromecast-title">
          {{ chromeCastTypes.fourK.title }}
        </th>
        <th class="chromecast-title">
          {{ chromeCastTypes.hd.title }}
        </th>
      </tr>
      <tr
        class="list-item underline"
        *ngFor="let feature of chromeCastTypes.fourK.features; let i = index"
      >
        <td class="column">
          <div *ngIf="!feature.isButton">
            <h3 class="main-title" [innerHTML]="feature.title"></h3>
            <div class="color-group" *ngIf="feature.images">
              <img
                width="50"
                height="50"
                *ngFor="let image of feature.images"
                class="color-icon"
                src="{{ image.src | assetpipe }}"
                [alt]="image.alt"
                [title]="image.alt"
              />
            </div>
            <svg
              *ngIf="feature.hasCheckMark"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 40 40"
              class="check-icon"
              style="enable-background: new 0 0 40 40"
              xml:space="preserve"
            >
              <path
                d="M0 20C0 9 9 0 20 0s20 9 20 20-9 20-20 20S0 31 0 20zm8 2.1 8 7.9 16-15.9-2.8-2.8L16 24.4l-5.2-5.2L8 22.1z"
              />
            </svg>
            <p *ngIf="feature.copy" class="subheading-title" [innerHTML]="feature.copy"></p>
          </div>
          <button *ngIf="feature.isButton" (click)="handleTitleClick($event)">
            <h3 class="main-title" [innerHTML]="feature.title"></h3>
            <div class="color-group" *ngIf="feature.images">
              <img
                width="50"
                height="50"
                *ngFor="let image of feature.images"
                class="color-icon"
                src="{{ image.src | assetpipe }}"
                [alt]="image.alt"
                [title]="image.alt"
              />
            </div>
            <svg
              *ngIf="feature.hasCheckMark"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 40 40"
              class="check-icon"
              style="enable-background: new 0 0 40 40"
              xml:space="preserve"
            >
              <path
                d="M0 20C0 9 9 0 20 0s20 9 20 20-9 20-20 20S0 31 0 20zm8 2.1 8 7.9 16-15.9-2.8-2.8L16 24.4l-5.2-5.2L8 22.1z"
              />
            </svg>
            <p *ngIf="feature.copy" class="subheading-title" [innerHTML]="feature.copy"></p>
          </button>
        </td>
        <td class="column">
          <div *ngIf="!chromeCastTypes.hd.features[i].isButton">
            <h3 class="main-title" [innerHTML]="chromeCastTypes.hd.features[i].title"></h3>
            <div class="color-group" *ngIf="feature.images">
              <img
                *ngFor="let image of chromeCastTypes.hd.features[i].images"
                class="color-icon"
                src="{{ image.src | assetpipe }}"
                [alt]="image.alt"
                [title]="image.alt"
              />
            </div>
            <svg
              *ngIf="chromeCastTypes.hd.features[i].hasCheckMark"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 40 40"
              class="check-icon"
              style="enable-background: new 0 0 40 40"
              xml:space="preserve"
            >
              <path
                d="M0 20C0 9 9 0 20 0s20 9 20 20-9 20-20 20S0 31 0 20zm8 2.1 8 7.9 16-15.9-2.8-2.8L16 24.4l-5.2-5.2L8 22.1z"
              />
            </svg>
            <p
              *ngIf="feature.copy"
              class="subheading-title"
              [innerHTML]="chromeCastTypes.hd.features[i].copy"
            ></p>
          </div>
          <button
            *ngIf="chromeCastTypes.hd.features[i].isButton"
            (click)="handleTitleClick($event)"
          >
            <h3 class="main-title" [innerHTML]="chromeCastTypes.hd.features[i].title"></h3>
            <div class="color-group" *ngIf="feature.images">
              <img
                *ngFor="let image of chromeCastTypes.hd.features[i].images"
                class="color-icon"
                src="{{ image.src | assetpipe }}"
                [alt]="image.alt"
                [title]="image.alt"
              />
            </div>
            <svg
              *ngIf="chromeCastTypes.hd.features[i].hasCheckMark"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 40 40"
              class="check-icon"
              style="enable-background: new 0 0 40 40"
              xml:space="preserve"
            >
              <path
                d="M0 20C0 9 9 0 20 0s20 9 20 20-9 20-20 20S0 31 0 20zm8 2.1 8 7.9 16-15.9-2.8-2.8L16 24.4l-5.2-5.2L8 22.1z"
              />
            </svg>
            <p
              *ngIf="feature.copy"
              class="subheading-title"
              [innerHTML]="chromeCastTypes.hd.features[i].copy"
            ></p>
          </button>
        </td>
      </tr>
    </table>
    <footer data-animation="c05-compare-modal-content">
      <div tabindex="-1" #footerButtonRef>
        <p
          *ngFor="let footerLine of footerCopy"
          class="footer-content"
          [innerHTML]="footerLine"
        ></p>
      </div>
    </footer>
  </div>
</div>
